<template>
  <div class="echarts-warp">
    <div class="echart-content">
      <div :id="getId" style="padding-top: 10px;height:100%;
    box-sizing: border-box;" v-resize="resize"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: "图表标题"
    },
    timeTitle: {
      type: String,
      default: ""
    },
    unit: {
      type: String,
      default: "kW"
    },
    /**
     * 是否显示图表标题
     */
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    data() {
      let vm = this;
      if (vm.data.length == 0 || vm.data.length == 1) {
        vm.drawLine();
      } else {
        vm.drawLines();
      }
    }
  },
  data() {
    return {
      id: "",
      myChart: null,
      isShow: false,
      height: 400
    };
  },
  computed: {
    getId() {
      let vm = this;
      vm.id =
        "chart" +
        (Math.random() * 10000000).toString(16).substr(0, 4) +
        "-" +
        new Date().getTime() +
        "-" +
        Math.random()
          .toString()
          .substr(2, 5);
      return vm.id;
    }
  },
  mounted() {
    let vm = this;
    window.addEventListener("resize", () => {
      if (vm.myChart) {
        vm.myChart.resize();
      }
    });
    if (vm.data.length == 0 || vm.data.length == 1) {
      vm.drawLine();
    }
  },
  methods: {
    resize(){
      let vm = this;
      vm.myChart && vm.myChart.resize();
    },
    drawLine() {
      let vm = this;
      let obj = vm.data[0];
      let series = [],
        xAxis = {},
        yAxis = [];
      // 判断是不是不规则的时间
        xAxis = {
          data: obj.xData,
        //   axisLabel: {
		// 			rotate: 40
		// 		},
        };
        obj.data.forEach((item,i) => {
            series.push({
                areaStyle:{
                    // color:  obj.color[i],opacity: "1"
                },
                name: obj.tip[i],
                type: "line",
                data:obj.data[i],
                stack: '总量',
                // color:['#3399FF'],  //折线条的颜色
                // markPoint : 
                // {
                //     // data : [
                //     // // {type : 'max', name: '最大值'},
                //     // {type : 'min', name: '最小值'}
                //     // ]
                // },
            })
        });
        series[0]["markPoint"]={
            data : [
            // {type : 'max', name: '最大值'},
                {type : 'min', name: '最小值'}
            ],
            itemStyle:{
                color:"#00388C"
            }
        }
        
      if (vm.myChart == null) {
        vm.myChart = vm.$echarts.init(document.getElementById(vm.id));
      } else {
        vm.myChart.clear();
      }
      // 绘制图表
      vm.myChart.setOption({
        title: {
          text: obj.title.replace(/[\r\n]/g, ""),
          left: "center"
        },
        tooltip: {
          trigger: "axis",
          confine:true,
          textStyle:{
                align:'left'
            },
          formatter(array){
            let str = ""
            for (let index = 0; index < array.length; index++) {
                const dataIndex = array[index].dataIndex;
                const data =  array[index].data;
                const seriesName =  array[index].seriesName;
                
                //index 指的是第几项。  dataIndex  第几天
                let val = obj.zbData[index][dataIndex]
                str+=`<span >${seriesName}:${data}  ${val}%</span><br/>`
            }
            return str;
          }
        },
        toolbox: {
          show: true,
          right: 20,
          feature: {
            saveAsImage: {},
            magicType: {
              type: ["line", "bar"]
            } //切换为折线图，切换为柱状图
          }
        },
        color:["#FAE5A2","#BFC5D3","#BFEEDA","#BED2FD"],
        grid: {
          left: "4%",
          right: "5%",
          top: "15%",
          bottom:"20%"
        },
        legend: {
            data: obj.tip,
            selected: obj.selected,
            left: "center",
            bottom: "4%",
            icon: "rect", // 这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 16, // 设置宽度
            itemHeight: 12, // 设置高度
        },
        // dataZoom: [
        //   {
        //     type: "inside",
        //     show: true,
        //     realtime: true
        //   },
        //   {
        //     show: true,
        //     realtime: true,
        //     end: 100,
        //     type: "slider",
        //     width: "92%",
        //     left: "center"
        //   }
        // ],
        xAxis: xAxis,
        yAxis: [
          {
            name: vm.unit,
            type: "value",
            scale: true
          }
        ],
        series: series
      });
      vm.isShow = true;
    },
    clickoTherAdd() {
      this.$emit("clickoTherAdd");
    },
  }
};
</script>
<style lang="scss" scoped>
.echarts-warp {
    width: 100%;
    padding: 14px;
    box-sizing: border-box;
    border-radius: 5px;
    background: #fff;
    border: 1px solid #dedcdc;
    height: 100%;
}
.echart-content {
    border-radius: 5px;
    border: 1px solid #dedcdc;
    overflow: hidden;
    position: relative;
    height: 100%;
}
.echarts-title {
  height: 34px;
  line-height: 34px;
  padding-left: 14px;
  color: #fff;
  background: #1d6ce9;
}
.iconlocal {
  position: absolute;
  top: 40px;
  right: 110px;
  z-index: 999;
  i {
    cursor: pointer;
  }
}
.iconlocal:hover {
  cursor: pointer;
  color: #1d6ce9;
}
.chartbox {
  position: absolute;
  top: 35px;
}
</style>
